import { ProjectStateDto } from 'services/APIs/InternalAPI/internal-api.contracts'

type KanbanEventMap = {
  REFRESH_ALL: null
  FETCH_NEXT_PAGE: {
    status: ProjectStateDto
    forcePage?: number
  }
  FETCH_NEXT_PAGE_ENDED: {
    projectState: ProjectStateDto
    success: boolean
    error: Error | undefined
    isLastPage: boolean
    lastPageFetched: number
  }
}

export function subscribeToKanbanEvents<T extends keyof KanbanEventMap>(
  eventType: T,
  callback: (eventData: KanbanEventMap[T]) => Promise<void> | void,
): { abort: (reason?: string) => void } {
  const abortController = new AbortController()

  window.addEventListener(
    eventType,
    (e) => {
      callback(e['detail'])
    },
    { signal: abortController.signal },
  )

  return abortController
}

export function dispatchKanbanEvents<T extends keyof KanbanEventMap>(
  eventType: T,
  eventData?: KanbanEventMap[T],
) {
  if (eventType === 'FETCH_NEXT_PAGE_ENDED') {
    // the fetch next page ended event is dispatched with a delay
    // to ensure that the event is not dispatched before the
    // scrollableLane is ready to handle it
    setTimeout(() => {
      window.dispatchEvent(
        new CustomEvent(eventType, {
          detail: eventData,
        }),
      )
    }, 200)

    return
  }

  window.dispatchEvent(new CustomEvent(eventType, { detail: eventData }))
}
